module.exports = __webpack_public_path__ + "static/media/x_icon_light.c7bf094b.svg";